import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

function getLocaleI18n () {
  const localeBrowser = navigator.language.toLocaleLowerCase()
  let valueLocale = ''
  if (localeBrowser.includes('en')) {
    valueLocale = 'en'
  } else if (localeBrowser.includes('ko')) {
    valueLocale = 'ko'
  } else if (localeBrowser.includes('cn')) {
    valueLocale = 'cn'
  } else {
    valueLocale = 'en'
  }
  return valueLocale
}

export default new VueI18n({
  locale: getLocaleI18n(),
  messages: loadLocaleMessages()
})
